import config from '@/configure/index';

import ReportIndexComponent from '@/components/tenancy/admin/report/Index.vue'
import ReportBestSellerComponent from '@/components/tenancy/admin/report/product/Bestseller.vue'
import ReportTotalSalesComponent from '@/components/tenancy/admin/report/SalesOrder/TotalSales.vue'
import ReportFinancePaymentComponent from '@/components/tenancy/admin/report/finance/PaymentReport.vue';
import ReportTemplateComponent from '@/components/tenancy/admin/report/Template.vue'
import ReportCashOnDelivery from '@/components/tenancy/admin/report/finance/Cod.vue'
import ReportCashOnDeliveryDetail from '@/components/tenancy/admin/report/finance/Detail.vue'
import ReportShippingExpenses  from '@/components/tenancy/admin/report/finance/ShippingExpensesReport.vue'
import ReportShippingExpensesDetail  from '@/components/tenancy/admin/report/finance/ShippingExpensesDetail.vue'
import ReportSalesByChannel  from '@/components/tenancy/admin/report/finance/SalesByChannel.vue'
import ReportSalesByProvince  from '@/components/tenancy/admin/report/finance/SalesByProvince.vue'
import ReportSalesByDaily from '@/components/tenancy/admin/report/SalesOrder/SalesDaily.vue'
import SaleContact  from '@/components/tenancy/admin/settings/sale/sale-contact/Index.vue'
import ReportGroupSalesOrderPayment  from '@/components/tenancy/admin/report/SalesOrder/GroupSalesOrderPayment.vue'
import Cookies from 'js-cookie'
import ReportProductSales from '@/components/tenancy/admin/report/product/ProductSales.vue'
import ReportProductSalesDetail from '@/components/tenancy/admin/report/product/ProductSalesDetail.vue'
import ReportProductSalesNormalDetail from '@/components/tenancy/admin/report/product/ProductSalesDetailNormal.vue'
import ReportProductSalesUpsellDetail from '@/components/tenancy/admin/report/product/ProductSalesDetailUpsell.vue'
import ReportCategoryComponent from '@/components/tenancy/admin/report/product/ProductCategory.vue'
import ReportInventory  from '@/components/tenancy/admin/report/inventory/Inventory.vue'
import ReportStoclAging from '@/components/tenancy/admin/report/inventory/StockAgingReport.vue'



const currentPackage = Cookies.get('plan')? JSON.parse(Cookies.get('plan')).group: null;
const rootUrlPath = '/' + config.adminPath;
let titleSuffix = ' ';

if(!!currentPackage) {
    if(currentPackage === 'goship') titleSuffix = 'GoShip ระบบหลังบ้านจัดการขนส่ง'
    if(currentPackage === 'gosell') titleSuffix = 'GoSell ระบบหลังบ้านเต็มรูปแบบ'
}


const tenancyRouter = [{
        path: '/',
        component: () =>
            import ('@/components/tenancy/admin/home/Index.vue'),
        name: 't.a.home',
        meta: {
            title: 'Home',
            meta_discription: 'Shipping platform built for eCommerce',
            layout: 'tenancy-admin-layout',
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + '/home/mobile',
        component: () =>
            import ('@/components/tenancy/admin/home/Index.vue'),
        name: 't.a.home.mobile',
        meta: {
            title: 'Home',
            layout: 'tenancy-admin-layout-no-header',
            suffix: titleSuffix
        }
    },
    {
        path: '/changelog',
        component: () =>
            import ('@/components/tenancy/admin/changelog/Index.vue'),
        name: 't.a.changelog',
        meta: { title: 'System Update',
        layout: 'tenancy-admin-layout',
        breadcrumb: [
            { name: 'System Update' },
        ],
        suffix: titleSuffix }
    },
    {
        path: rootUrlPath + '/account-setting/Index',
        component: () =>
            import ('@/components/tenancy/admin/account-setting/Index.vue'),
        name: 't.a.account-setting',
        meta: {
            title: 'Account Settings',
            layout: 'tenancy-admin-layout',
            breadcrumb: [
                { name: 'Account Settings' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + '/2c2p/callback/success',
        component: () =>
            import ('@/components/tenancy/admin/callback/2c2p/Success.vue'),
        name: 't.a.account-setting-success',
        meta: {
            title: 'Payment',
            layout: 'TenancyPublicLayout',
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + '/2c2p/callback/failed',
        component: () =>
            import ('@/components/tenancy/admin/callback/2c2p/Failed.vue'),
        name: 't.a.account-setting.failed',
        meta: {
            title: 'Payment',
            layout: 'TenancyPublicLayout',
            suffix: titleSuffix
        }
    },

    {
        path: '/checkout/success',
        component: () =>
            import ('@/components/tenancy/admin/callback/2c2p/Success.vue'),
        name: 't.a.account-setting-success',
        meta: {
            title: 'Payment',
            layout: 'TenancyPublicLayout',
            suffix: titleSuffix
        }
    },
    {
        path: '/checkout/failed',
        component: () =>
            import ('@/components/tenancy/admin/callback/2c2p/Failed.vue'),
        name: 't.a.account-setting.failed',
        meta: {
            title: 'Payment',
            layout: 'TenancyPublicLayout',
            suffix: titleSuffix
        }
    },

    {
        path: rootUrlPath + '/dashboard',
        component: () =>
            import ('@/components/tenancy/admin/dashboard/Index.vue'),
        name: 't.a.dashboard',
        meta: {
            title: 'Dashboard',
            icon: 'dashboard',
            layout: 'tenancy-admin-layout',
            breadcrumb: [
                { name: 'Dashboard' },
            ],
            suffix: titleSuffix
        }
    },
    // {
    //     path: rootUrlPath + '/dashboard/mobile',
    //     component: () =>
    //         import ('@/components/tenancy/admin/dashboard/Shop.vue'),
    //     name: 't.a.dashboard.shop',
    //     meta: {
    //         title: 'Dashboard',
    //         icon: 'dashboard',
    //         layout: 'tenancy-admin-layout-no-header',
    //         breadcrumb: [
    //             { name: 'Dashboard' },
    //         ],
    //         suffix: titleSuffix
    //     }
    // },
    {
        path: '/invite/form',
        component: () =>
            import ('@/components/tenancy/frontend/user/InviteForm.vue'),
        name: 't.f.inviteform',
        meta: {
            title: 'invite form',
            icon: 'dashboard',
            layout: 'tenancy-front-layout',
            breadcrumb: [
                { name: 'invite form' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: '/invite/:invite_code',
        component: () =>
            import ('@/components/tenancy/frontend/user/Invite.vue'),
        name: 't.f.user',
        meta: {
            title: 'invite',
            icon: 'dashboard',
            layout: 'tenancy-front-layout',
            breadcrumb: [
                { name: 'invite' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/orders/index",
        name: "t.a.order.index",
        component: () =>
            import ('@/components/tenancy/admin/orders/Index.vue'),
        meta: {
            title: 'Orders',
            icon: '',
            layout: 'tenancy-admin-layout',
            breadcrumb: [
                { name: 'Orders' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/orders/:id",
        name: "t.a.order.view",
        component: () =>
            import ('@/components/tenancy/admin/orders/Detail.vue'),
        meta: {
            title: 'Orders',
            icon: '',
            layout: 'tenancy-admin-layout',
            breadcrumb: [
                { name: 'Orders', link: rootUrlPath + '/orders/index' },
                { name: 'Order details' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/orders/abandoned_checkouts",
        name: "t.a.order.abandoned",
        component: () =>
            import ('@/components/tenancy/admin/orders/Index.vue'),
        meta: {
            title: 'abandoned checkouts',
            icon: '',
            layout: 'tenancy-admin-layout',
            breadcrumb: [
                { name: 'abandoned checkouts' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/orders/drafts/index",
        name: "t.a.ordersdrafts.index",
        component: () =>
            import ('@/components/tenancy/admin/ordersdrafts/Index.vue'),
        meta: {
            title: 'Order Drafts',
            icon: '',
            layout: 'tenancy-admin-layout',
            breadcrumb: [
                { name: 'Orders' },
                { name: 'Order Drafts' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/orders/drafts/:id",
        name: "t.a.ordersdrafts.view",
        component: () =>
            import ('@/components/tenancy/admin/ordersdrafts/Detail.vue'),
        meta: {
            title: 'Order Drafts',
            icon: '',
            layout: 'tenancy-admin-layout',
            breadcrumb: [
                { name: 'Orders'},
                { name: 'Order Drafts', link: rootUrlPath + '/orders/drafts/index' },
                { name: 'Order Draft Details' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/shipment",
        name: "t.a.shipment",
        component: () =>
            import ('@/components/tenancy/admin/shipment/ShipmentIndex.vue'),
        meta: {
            //  middleware: role,
            title: 'Shipment',
            icon: '',
            layout: 'tenancy-admin-layout',
            breadcrumb: [
                { name: 'Shipment' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/customer",
        name: "t.a.customer",
        component: () =>
            import ('@/components/tenancy/admin/customer/Customer.vue'),
        meta: {
            title: 'Customer',
            icon: '',
            breadcrumb: [
                { name: 'Customer' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/customer/view/:id",
        name: "t.a.customer.view",
        component: () =>
            import ('@/components/tenancy/admin/customer/CustomerView.vue'),
        meta: {
            title: 'Customer Detail',
            icon: '',
            breadcrumb: [
                { name: 'Customer', link: rootUrlPath + '/customer' },
                { name: 'Customer Detail' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath,
        name: "admin.crm",
        component: () =>
            import ('@/components/tenancy/admin/crm/Template.vue'),
        children: [
            {
                name: 'admin.crm.upsell',
                path: 'upsell',
                component: () =>
                    import ('@/components/tenancy/admin/crm/upsell/UpsellIndex.vue'),
                meta: {
                    title: 'Order Upsell',
                    icon: '',
                    breadcrumb: [
                        { name: 'Upsell' }
                    ]
                },
            },
            {
                name: 'admin.crm.activities',
                path: 'activities',
                component: () =>
                import ('@/components/tenancy/admin/crm/activities/Index.vue'),
                meta: {
                    title: 'Activities',
                    icon: '',
                    breadcrumb: [
                        { name: 'Activities' }
                    ]
                },
            },
            {
                name: 'admin.crm.upsell.setting',
                path: 'upsell/setting',
                component: () =>
                    import ('@/components/tenancy/admin/crm/upsell/setting/Index.vue'),
                meta: {
                    title: 'Upsell Setting',
                    icon: '',
                    breadcrumb: [
                        { name: "Settings", link: rootUrlPath + "/settings/crm" },
                        { name: 'Upsell Setting' }
                    ]
                },
            }
        ]
    },
    {
        path: rootUrlPath + "/users",
        name: "t.a.users",
        meta: {
            title: 'User',
            icon: '',
            breadcrumb: [
                { name: 'User' },
            ],
            suffix: titleSuffix
        },
        component: () =>
            import ('@/components/tenancy/admin/users/Index.vue')
    },
    {
        path: rootUrlPath + "/roles",
        name: "t.a.roles",
        meta: {
            title: 'Role',
            icon: '',
            breadcrumb: [
                { name: 'Role' },
            ],
            suffix: titleSuffix
        },
        component: () =>
            import ('@/components/tenancy/admin/roles/Index.vue')
    },
    {
        path: rootUrlPath + "/integrations",
        name: "t.a.integrations",
        meta: {
            title: 'Integrations',
            icon: '',
            breadcrumb: [
                { name: 'Integrations' },
            ],
            suffix: titleSuffix
        },
        component: () =>
            import ('@/components/tenancy/admin/Integrateorigin/Index.vue')
    },
    {
        path: rootUrlPath,
        name: "admin.reports",
        component: ReportTemplateComponent,
        children: [{
                name: 'admin.reports.index',
                path: 'reports',
                component: ReportIndexComponent,
                meta: {
                    title: 'Reports',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports' }
                    ]
                },
            },
            {
                name: 'admin.reports.products.bestSeller',
                path: 'reports/products/ReportBestSeller',
                component: ReportBestSellerComponent,
                meta: {
                    title: 'Best Seller Report',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Best Seller Report' }
                    ]
                },
            },
            {
                name: 'admin.reports.products.category',
                path: 'reports/products/report-category',
                component: ReportCategoryComponent,
                meta: {
                    title: 'Product Sales Report By Category',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Product Sales Report By Category' }
                    ]
                },
            },
            {
                name: 'admin.reports.products.sales',
                path: 'reports/products/ReportProductSales',
                component: ReportProductSales,
                meta: {
                    title: 'Product Sales Report',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Product Sales Report' }
                    ]
                },
            },
            {
                name: 'admin.reports.products.salesDetail',
                path: 'reports/products/ReportProductSalesDetail/:id/:startDate/:endDate',
                component: ReportProductSalesDetail,
                meta: {
                    title: 'Total Sales Details',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports"},
                        { name: 'Product Sales Report', link: rootUrlPath + "/reports/products/ReportProductSales"},
                        { name: 'Total Sales Details' }
                    ]
                },
            },
            {
                name: 'admin.reports.products.salesDetailNormal',
                path: 'reports/products/ReportProductSalesDetailNormal/:id/:startDate/:endDate',
                component: ReportProductSalesNormalDetail,
                meta: {
                    title: 'Product Sales Report Details',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports"},
                        { name: 'Product Sales Report', link: rootUrlPath + "/reports/products/ReportProductSales"},
                        { name: 'Product Sales Report Details' }
                    ]
                },
            },
            {
                name: 'admin.reports.products.salesDetailUpsell',
                path: 'reports/products/ReportProductSalesDetailUpsell/:id/:startDate/:endDate',
                component: ReportProductSalesUpsellDetail,
                meta: {
                    title: 'Total Upsell Details',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports"},
                        { name: 'Product Sales Report', link: rootUrlPath + "/reports/products/ReportProductSales"},
                        { name: 'Total Upsell Details' }
                    ]
                },
            },
            {
                name: 'admin.reports.orders.totalSales',
                path: 'reports/orders/ReportTotalSales',
                component: ReportTotalSalesComponent,
                meta: {
                    title: 'Total Sales Report',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Total Sales Report' }
                    ]
                },
            },
            {
                name: 'admin.reports.orders.totalPayments',
                path: 'reports/orders/ReportTotalPayments',
                component: ReportFinancePaymentComponent,
                meta: {
                    title: 'Sales Report By Payment Channel',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Sales Report By Payment Channel' }
                    ]
                },
            },
            {
                name: 'admin.reports.orders.groupSalesOrderPayment',
                path: 'reports/orders/GroupSalesOrderPayment',
                component: ReportGroupSalesOrderPayment,
                meta: {
                    title: 'Bank Account Payment Report',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Bank Account Payment Report' }
                    ]
                },
            },
            {
                name: 'admin.reports.orders.upsell',
                path: 'reports/orders/upsell',
                component: () =>
                    import ('@/components/tenancy/admin/report/SalesOrder/UpsellReport.vue'),
                meta: {
                    title: 'Sales Report by Order Upsell',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Sales Report by Order Upsell' }
                    ]
                },
            },
            {
                name: 'admin.reports.orders.salepage',
                path: 'reports/orders/SalesReportBySalepage',
                component: () =>
                    import ('@/components/tenancy/admin/report/SalesOrder/Salepage.vue'),
                meta: {
                    title: 'Sales Report by Sale Page',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Sales Report by Sale Page' }
                    ]
                },
            },
            {
                name: 'admin.reports.orders.salesReportByDaily',
                path: 'reports/orders/SalesDailyReport',
                component: ReportSalesByDaily,
                meta: {
                    title: 'Sales Report by Daily and Period',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Sales Report by Daily and Period' }
                    ]
                },
            },
            {
                name: 'admin.reports.orders.dailyDetail',
                path: 'reports/orders/dailyDetail/:dayCode/:month/:year/',
                component: () =>
                    import ('@/components/tenancy/admin/report/SalesOrder/saledaily/SalesDailyDetail.vue'),
                meta: {
                    title: '_reports.Detail total daily sales and period',
                    icon: '',
                    layout: 'tenancy-admin-layout',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Sales Report by Daily and Period', link: rootUrlPath + "/reports/orders/SalesDailyReport" },
                        { name: '_reports.Detail total daily sales and period' }
                    ],
                    suffix: titleSuffix
                }
            },
            {
                name: 'admin.reports.orders.voiceCall',
                path: 'reports/orders/voiceCall',
                component: () =>
                    import ('@/components/tenancy/admin/report/voicecall/VoiceCallReport.vue'),
                meta: {
                    title: 'Call History Report',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Call History Report' }
                    ]
                },
            },
            {
                name: 'admin.reports.orders.voiceCallDetail',
                path: 'reports/orders/voiceCallDetail/:id',
                component: () =>
                    import ('@/components/tenancy/admin/report/voicecall/VoiceCallDetailReport.vue'),
                meta: {
                    title: 'Call History Report Details',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Call History Report', link: rootUrlPath + "/reports/orders/voiceCall"},
                        { name: 'Call History Report Details' }
                    ]
                },
            },
            {
                name: 'admin.reports.payments.cashOnDelivery',
                path: 'reports/payments/ReportCashOnDelivery',
                component: ReportCashOnDelivery,
                meta: {
                    title: 'Cash on delivery payment report (COD)',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Cash on delivery payment report (COD)' }
                    ]
                },
            },
            {
                name: 'admin.reports.payments.cashOnDeliveryDetail',
                path: 'reports/payments/ReportCashOnDelivery/:id/:cod_account_id',
                component: ReportCashOnDeliveryDetail,
                meta: {
                    title: 'Cash on delivery payment report (COD)',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Cash on delivery payment report (COD)', link: rootUrlPath + "/reports/payments/ReportCashOnDelivery" },
                        { name: 'Billing details' }
                    ]
                },
            },
            {
                name: 'admin.reports.payments.shippingExpensesReport',
                path: 'reports/payments/ShippingExpensesReport',
                component: ReportShippingExpenses,
                meta: {
                    title: 'Shipping Charge Billing Report',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports"},
                        { name: 'Shipping Charge Billing Report' }
                    ]
                },
            },
            {
                name: 'admin.reports.payments.shippingExpensesDetail',
                path: 'reports/payments/ShippingExpensesReportDetail',
                component: ReportShippingExpensesDetail,
                meta: {
                    title: 'Shipping Charge Billing Detail',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports"},
                        { name: 'Shipping Charge Billing Report', link: rootUrlPath + "/reports/payments/ShippingExpensesReport"},
                        { name: 'Shipping Charge Billing Detail' }
                    ]
                },
            },
            {
                name: 'admin.reports.orders.reportByChannel',
                path: 'reports/orders/sales-by-channel',
                component: ReportSalesByChannel,
                meta: {
                    title: '_ReportChannel.Sales Order Report by Channel',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports"},
                        { name: '_ReportChannel.Sales Order Report by Channel' }
                    ]
                },
            },
            {
                name: 'admin.reports.orders.reportByChannelDetail',
                path: 'reports/orders/sales-by-channel/:id',
                component: ReportSalesByChannel,
                meta: {
                    title: 'Sales Order Report by Channel',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports"},
                        { name: 'Sales Order Report by Channel', link: rootUrlPath + "/reports/orders/SalesByChannel"},
                        { name: 'Sales Order Report by Channel Details' }
                    ]
                },
            },
            {
                name: 'admin.reports.orders.salesReportByProvince',
                path: 'reports/orders/SalesByProvince',
                component: ReportSalesByProvince,
                meta: {
                    title: 'Sales Report By Province',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports"},
                        { name: 'Sales Report By Province' }
                    ]
                },
            },
            {
                name: 'admin.reports.Inventory.ReportInventory',
                path: 'reports/inventory/ReportInventory',
                component: ReportInventory,
                meta: {
                    title: 'Inventory Report',
                    icon: '',
                    breadcrumb: [
                        { name: 'Reports', link: rootUrlPath + "/reports" },
                        { name: 'Inventory Report' }
                    ]
                },
            },
            {
              name: 'admin.reports.Inventory.StockAgingReport',
              path: 'reports/inventory/StockAgingReport',
              component: ReportStoclAging,
              meta: {
                  title: 'Stock Aging Report',
                  icon: '',
                  breadcrumb: [
                      { name: 'Reports', link: rootUrlPath + "/reports" },
                      { name: 'Stock Aging Report' }
                  ]
              },
            }

        ]

    },
    {
        path: rootUrlPath,
        name: "admin.tools",
        component: () =>
            import ('@/components/tenancy/admin/tool/Template.vue'),
        children: [
            {
                name: 'admin.tools.index',
                path: 'tools',
                component: () =>
                    import ('@/components/tenancy/admin/tool/Index.vue'),
                meta: {
                    title: 'Tools',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools' }
                    ]
                },
            },
            {
                name: 'admin.tools.import.Orders',
                path: 'tools/import-orders',
                component: () =>
                    import ('@/components/tenancy/admin/tool/import/order/Order.vue'),
                meta: {
                    title: 'Tools',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Import Orders' }
                    ]
                },
            },
            {
                name: 'admin.tools.import.Products',
                path: 'tools/import-products',
                component: () =>
                    import ('@/components/tenancy/admin/tool/import/product/Product.vue'),
                meta: {
                    title: 'Tools',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Import Products' }
                    ]
                },
            },
            {
                name: 'admin.tools.import.Customers',
                path: 'tools/import-customers',
                component: () =>
                    import ('@/components/tenancy/admin/tool/import/customer/Customer.vue'),
                meta: {
                    title: 'Tools',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Import Customers' }
                    ]
                },
            },
            {
                name: 'admin.tools.customize.TagsManagement',
                path: 'tools/tags-management',
                component: () =>
                    import ('@/components/tenancy/admin/tool/customize/TagsManagement.vue'),
                meta: {
                    title: 'Tools',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Tags Management' }
                    ]
                },
            },
            {
                name: 'admin.tools.customize.Forms',
                path: 'tools/forms',
                component: () =>
                    import ('@/components/tenancy/admin/tool/customize/forms/Index.vue'),
                meta: {
                    title: 'Forms',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Forms' }
                    ]
                },
            },
            {
                name: "admin.tools.customize.Forms.Create",
                path: 'tools/forms/create',
                component: () =>
                    import ('@/components/tenancy/admin/tool/customize/forms/form/formView.vue'),
                meta: {
                    title: 'Create Form',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Forms', link: rootUrlPath + "/tools/forms" },
                        { name: 'Create Form' },
                    ],
                }
            },
            {
                name: "admin.tools.customize.Forms.Duplicate",
                path: 'tools/forms/duplicate/:id',
                component: () =>
                    import ('@/components/tenancy/admin/tool/customize/forms/form/formView.vue'),
                meta: {
                    title: 'Duplicate Form',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Forms', link: rootUrlPath + "/tools/forms" },
                        { name: 'Duplicate Form' },
                    ],
                }
            },
            {
                name: "admin.tools.customize.Forms.Edit",
                path: 'tools/forms/edit/:id',
                component: () =>
                    import ('@/components/tenancy/admin/tool/customize/forms/form/formView.vue'),
                meta: {
                    title: 'Edit Form',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Forms', link: rootUrlPath + "/tools/forms" },
                        { name: 'Edit Form' },
                    ],
                }
            },
            {
                name: 'admin.tools.customize.Forms.Entry.List',
                path: 'tools/forms/view/:id/entries',
                component: () =>
                    import ('@/components/tenancy/admin/tool/customize/forms/entry/Index.vue'),
                meta: {
                    title: 'Entry Details',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Forms', link: rootUrlPath + "/tools/forms" },
                        { name: 'Entry Details' },
                    ]
                },
            },
            {
                name: 'admin.tools.customize.Packaging',
                path: 'tools/packaging-size',
                component: () =>
                    import ('@/components/tenancy/admin/tool/customize/packaging/Index.vue'),
                meta: {
                    title: 'Packaging Size',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Packaging Size' }
                    ]
                },
            },
            {
                name: 'admin.tools.customize.Forms.Entry.ScanQrCode',
                path: 'tools/forms/view/:id/scan-qr-code',
                component: () =>
                    import ('@/components/tenancy/admin/tool/customize/forms/entry/ScanQrCode.vue'),
                meta: {
                    title: 'Scan Qr Code',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Forms', link: rootUrlPath + "/tools/forms" },
                        { name: 'Entry Details', link: rootUrlPath + "/tools/forms/view/:id/entries" },
                        { name: 'Scan Qr Code' },
                    ]
                },
            },
            {
                name: 'admin.tools.import.ConfirmCod',
                path: 'tools/import-confirm-cod',
                component: () =>
                    import ('@/components/tenancy/admin/tool/import/confirm-cod/Index.vue'),
                meta: {
                    title: 'Tools',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Import confirm cod received' }
                    ]
                },
            },
            {
                name: 'admin.tools.export.Orders',
                path: 'tools/export-orders',
                component: () =>
                    import ('@/components/tenancy/admin/tool/export/order/Order.vue'),
                meta: {
                    title: 'Export Orders',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Export Orders' }
                    ]
                },
            },
            {
                name: 'admin.tools.export.customer',
                path: 'tools/export-customers',
                component: () =>
                    import ('@/components/tenancy/admin/tool/export/customer/customer.vue'),
                meta: {
                    title: 'Export Customers',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Export Customer' }
                    ]
                },
            },
            {
                name: 'admin.tools.export.product',
                path: 'tools/export-products',
                component: () =>
                    import ('@/components/tenancy/admin/tool/export/product/Product.vue'),
                meta: {
                    title: 'Export Products',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Export Products' }
                    ]
                },
            },
            {
                name: 'admin.tools.export.stocks',
                path: 'tools/export-stocks',
                component: () =>
                    import ('@/components/tenancy/admin/tool/export/stocks/Stocks.vue'),
                meta: {
                    title: 'Export Stock Balance',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Export Stock Balance' }
                    ]
                },
            },
            {
                name: 'admin.tools.export.productlink',
                path: 'tools/export-productlink',
                component: () =>
                    import ('@/components/tenancy/admin/tool/export/productlink/ProductLink.vue'),
                meta: {
                    title: 'Export Product Link',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Export Product Link' }
                    ]
                },
            },
            {
                name: 'admin.tools.export.marketplacestockmovement',
                path: 'tools/export-marketplace-stock-movement',
                component: () =>
                    import ('@/components/tenancy/admin/tool/export/marketplace/StockMovement.vue'),
                meta: {
                    title: 'Export Marketplace Stock Movement',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Export Marketplace Stock Movement' }
                    ]
                },
            },
            {
                name: 'admin.tools.print.product-label',
                path: 'tools/product-label',
                component: () =>
                    import ('@/components/tenancy/admin/tool/print/product-label/Index.vue'),
                meta: {
                    title: 'Product Label',
                    icon: '',
                    breadcrumb: [
                        { name: 'Tools', link: rootUrlPath + "/tools" },
                        { name: 'Product Label' }
                    ]
                },
            },
            {
              name: 'admin.tools.export.stocksmovement',
              path: 'tools/export-stocksmovement',
              component: () =>
                import ('@/components/tenancy/admin/tool/export/stocksmovement/StocksMovement.vue'),
              meta: {
                title: 'Export Stock Movement',
                icon: '',
                breadcrumb: [
                    { name: 'Tools', link: rootUrlPath + "/tools" },
                    { name: 'Export Stock Movement' }
                ]
            },
            },
        ]
    },
    // {
    //     path: rootUrlPath + "/settings",
    //     name: "t.a.settings",
    //     component: () =>
    //         import ('@/components/tenancy/admin/settings/Index.vue'),
    //     meta: {
    //         layout: 'tenancy-admin-layout',
    //         title: 'Settings',
    //         icon: '',
    //         breadcrumb: [
    //             { name: "Settings", link: rootUrlPath + "/settings" },
    //         ],
    //         suffix: titleSuffix
    //     }
    // },
    {
        path: rootUrlPath + "/settings",
        name: "t.a.settings",
        component: () =>
            import ('@/components/v2/tenancy/admin/settings/Index.vue'),
        meta: {
            layout: 'tenancy-admin-layout',
            title: 'Settings',
            icon: '',
            breadcrumb: [
                { name: "Settings" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/general",
        name: "t.a.settings.general",
        component: () =>
            import ('@/components/tenancy/admin/settings/menu-setting/SettingGeneral.vue'),
        meta: {
            layout: 'tenancy-admin-layout',
            title: 'Settings',
            icon: '',
            breadcrumb: [
                { name: "Settings" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/ecommerce-and-finance",
        name: "t.a.settings.ecommerce-finance",
        component: () =>
            import ('@/components/tenancy/admin/settings/menu-setting/SettingEcommerce&Finance.vue'),
        meta: {
            layout: 'tenancy-admin-layout',
            title: 'Settings',
            icon: '',
            breadcrumb: [
                { name: "Settings" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/buying-selling",
        name: "t.a.settings.buying-selling",
        component: () =>
            import ('@/components/tenancy/admin/settings/menu-setting/SettingBuying&Selling.vue'),
        meta: {
            layout: 'tenancy-admin-layout',
            title: 'Settings',
            icon: '',
            breadcrumb: [
                { name: "Settings" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/message-template",
        name: "t.a.settings.messagetemplate",
        component: () =>
            import ('@/components/tenancy/admin/settings/menu-setting/SettingMessageTemplate.vue'),
        meta: {
            layout: 'tenancy-admin-layout',
            title: 'Settings',
            icon: '',
            breadcrumb: [
                { name: "Settings" },
                { name: "Message Template" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/document",
        name: "t.a.settings.document",
        component: () =>
            import ('@/components/tenancy/admin/settings/menu-setting/SettingDocument.vue'),
        meta: {
            layout: 'tenancy-admin-layout',
            title: 'Settings',
            icon: '',
            breadcrumb: [
                { name: "Settings" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/notification",
        name: "t.a.settings.notifications",
        component: () =>
            import ('@/components/tenancy/admin/settings/menu-setting/SettingNotifications.vue'),
        meta: {
            layout: 'tenancy-admin-layout',
            title: 'Settings',
            icon: '',
            breadcrumb: [
                { name: "Settings" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/crm",
        name: "t.a.settings.crm",
        component: () =>
            import ('@/components/tenancy/admin/settings/menu-setting/SettingCRM.vue'),
        meta: {
            layout: 'tenancy-admin-layout',
            title: 'Settings',
            icon: '',
            breadcrumb: [
                { name: "Settings" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/business-info",
        name: "t.a.settings.business-info",
        component: () =>
            import ('@/components/tenancy/admin/settings/general/BusinessInfo.vue'),
        meta: {
            title: 'Business Info',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/general" },
                { name: "Business Info", link: rootUrlPath + "/settings/business-info" }
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/language-region",
        name: "t.a.settings.settings/language-region",
        component: () =>
            import ('@/components/tenancy/admin/settings/general/LanguageRegion.vue'),
        meta: {
            title: 'Settings',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/general" },
                { name: "Language & Region", link: "/settings/language-region" }
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/payments",
        name: "t.a.settings.payments",
        component: () =>
            import ('@/components/tenancy/admin/settings/SettingPayment'),
        meta: {
            title: 'Payments',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/ecommerce-and-finance" },
                { name: "Payments", link: rootUrlPath + "/settings/payments" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/shipping-delivery",
        name: "t.a.settings.shipping-delivery",
        component: () =>
            import ('@/components/tenancy/admin/settings/shipping-delivery/Index'),
        meta: {
            title: 'Shipping & Delivery',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/ecommerce-and-finance" },
                { name: "Shipping & Delivery", link: rootUrlPath + "/settings/shipping-delivery" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/seo/salepage",
        name: "a.t.settings.salepage",
        component: () =>
            import ('@/components/tenancy/admin/settings/seo/salepage/Index.vue'),
        meta: {
            title: 'SEO Salepage',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings" },
                { name: "Salepage", link: rootUrlPath + "/settings/seo/salepage" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath+ "/salepage",
        name: 't.a.salepage',
        component: () => import ('@/components/tenancy/admin/salepage/Index.vue'),
        meta: {
            title: 'Sale Page',
            icon: '',
            breadcrumb: [
                { name: 'Sale Page' }
            ],
        },
    },
    {
        path: rootUrlPath + "/salepage/create",
        name: "t.a.salepage.create",
        component: () =>
            import ('@/components/tenancy/admin/salepage/SalepageView.vue'),
        meta: {
            title: 'Sale Page View',
            icon: '',
            breadcrumb: [
                { name: 'Sale Page', link: rootUrlPath + '/salepage' },
                { name: 'Sale Page Create' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/salepage/view/:id",
        name: "t.a.salepage.view",
        component: () =>
            import ('@/components/tenancy/admin/salepage/SalepageView.vue'),
        meta: {
            title: 'Sale Page View',
            icon: '',
            breadcrumb: [
                { name: 'Sale Page', link: rootUrlPath + '/salepage' },
                { name: 'Sale Page View' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/line-connect/syncstatus/:status",
        name: "t.a.lineConnect.SyncStatus",
        component: () =>
            import ('@/components/tenancy/admin/salepage/SyncStatus.vue'),
        meta: {
            title: 'Line Connection',
            layout: 'TenancyPublicLayout',
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/slack-connect/syncstatus/:status",
        name: "t.a.Notification.SyncStatus",
        component: () =>
            import ('@/components/tenancy/admin/settings/notification/SyncStatus.vue'),
        meta: {
            title: 'Slack Connection',
            layout: 'TenancyPublicLayout',
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/domain",
        name: "t.a.domain",
        component: () =>
            import ('@/components/tenancy/admin/domain/Index.vue'),
        meta: {
            title: 'Domains',
            icon: '',
            breadcrumb: [
                { name: 'Domains', link: rootUrlPath + '/domain' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/domain/create",
        name: "t.a.domain.create",
        component: () =>
            import ('@/components/tenancy/admin/domain/CreateDomain.vue'),
        meta: {
            title: 'Create Domain',
            icon: '',
            breadcrumb: [
                { name: 'Domains', link: rootUrlPath + '/domain' },
                { name: "Create Domain" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/domain/:id",
        name: "t.a.domain.view",
        component: () =>
            import ('@/components/tenancy/admin/domain/DomainDetail.vue'),
        meta: {
            title: 'Domain Detail',
            icon: '',
            breadcrumb: [
                { name: 'Domains', link: rootUrlPath + '/domain' },
                { name: "Domain Detail" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/billing-format/index",
        name: "t.a.settings.billing-format.index",
        component: () =>
            import ('@/components/tenancy/admin/settings/document/billing-format/Index.vue'),
        meta: {
            title: 'Billing Format',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings" },
                { name: "Billing Format" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/notification/order",
        name: "t.a.settings.notification.order",
        component: () =>
            import ('@/components/tenancy/admin/settings/notification/order/line/Index.vue'),
        meta: {
            title: 'Order Notifications',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/notification" },
                { name: "Order Notifications" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/message-template/order",
        name: "t.a.settings.message-template.order",
        component: () =>
            import ('@/components/tenancy/admin/settings/message-template/Order.vue'),
        meta: {
            title: 'Order Message',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/message-template" },
                { name: "Order Message" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/message-template/order-draft",
        name: "t.a.settings.message-template.order-draft",
        component: () =>
            import ('@/components/tenancy/admin/settings/message-template/OrderDraft.vue'),
        meta: {
            title: 'Order Draft Message',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/message-template" },
                { name: "Order Draft Message" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/message-template/shipment",
        name: "t.a.settings.message-template.shipment",
        component: () =>
            import ('@/components/tenancy/admin/settings/message-template/Shipment.vue'),
        meta: {
            title: 'Shipment Message',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/message-template" },
                { name: "Shipment Message" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/notification/upsell",
        name: "t.a.settings.notification.upsell",
        component: () =>
            import ('@/components/tenancy/admin/settings/notification/upsell/line/Index.vue'),
        meta: {
            title: 'Upsell Notification',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/notification" },
                { name: "Upsell Notification" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/notification/cod",
        name: "t.a.settings.notification.cod",
        component: () => import ('@/components/tenancy/admin/settings/notification/COD/line/Index.vue') ,
        meta: {
            title: 'COD Notification',
            layout: 'tenancy-admin-layout',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/notification" },
                { name: "COD Notification" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/notification/shipment",
        name: "t.a.settings.notification.shipment",
        component: () => import ('@/components/tenancy/admin/settings/notification/shipment/line/Index.vue') ,
        meta: {
            title: 'Shipment Notifications',
            layout: 'tenancy-admin-layout',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/notification" },
                { name: "Shipment Notifications" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/notification/subscription",
        name: "t.a.settings.notification.subscription",
        component: () =>
            import ('@/components/tenancy/admin/settings/notification/subscription/line/Index.vue'),
        meta: {
            title: 'Subscription Notification',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/notification" },
                { name: "Subscription Notification" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/document/shipping-label",
        name: "t.a.settings.document.shipping-label",
        component: () =>
            import ('@/components/tenancy/admin/settings/document/shipping-label/Index.vue'),
        meta: {
            title: 'Shipping Label',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/document" },
                { name: "Document", link: rootUrlPath + "/settings/document"  },
                { name: "Shipping Label" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/document/receipts",
        name: "t.a.settings.document.receipts",
        component: () =>
            import ('@/components/tenancy/admin/settings/document/receipts/Index.vue'),
        meta: {
            title: 'Receipts',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/document" },
                { name: "Document", link: rootUrlPath + "/settings/document"  },
                { name: "Receipts" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/document/receipt-tax-invoice",
        name: "t.a.settings.document.receipt-tax-invoice",
        component: () =>
            import ('@/components/tenancy/admin/settings/document/receipt-tax-invoice/Index.vue'),
        meta: {
            title: 'Receipt/Tax invoice',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/document" },
                { name: "Document", link: rootUrlPath + "/settings/document"  },
                { name: "Receipt/Tax invoice" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/document/delivery",
        name: "t.a.settings.document.delivery",
        component: () =>
            import ('@/components/tenancy/admin/settings/document/delivery/Index.vue'),
        meta: {
            title: 'Delivery Note',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/document" },
                { name: "Document", link: rootUrlPath + "/settings/document"  },
                { name: "Delivery Note" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/document/tax-invoices",
        name: "t.a.settings.document.tax-invoices",
        component: () =>
            import ('@/components/tenancy/admin/settings/document/tax-invoices/Index.vue'),
        meta: {
            title: 'Tax Invoices',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/document" },
                { name: "Document", link: rootUrlPath + "/settings/document"  },
                { name: "Tax Invoices" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/document/picking-list",
        name: "t.a.settings.document.picking-list",
        component: () =>
            import ('@/components/tenancy/admin/settings/document/picking-list/Index.vue'),
        meta: {
            title: 'Picking List',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/document" },
                { name: "Picking List" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/document/delivery-proof",
        name: "t.a.settings.document.delivery-proof",
        component: () =>
            import ('@/components/tenancy/admin/settings/document/delivery-proof/Index.vue'),
        meta: {
            title: 'Proof of Delivery',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/document" },
                { name: "Proof of Delivery" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/document/quotation",
        name: "t.a.settings.document.quotation",
        component: () =>
            import ('@/components/tenancy/admin/settings/document/quotation/Index.vue'),
        meta: {
            title: 'Quotation',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/document" },
                { name: "Quotation" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/document/purchase-order",
        name: "t.a.settings.document.purchase-order",
        component: () =>
            import ('@/components/tenancy/admin/settings/document/purchase-order/Index.vue'),
        meta: {
            title: 'Purchase Order',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/document" },
                { name: "Purchase Order" },
            ],
            suffix: titleSuffix
        }
    },
    {
      path: rootUrlPath + "/settings/document/transfer-product",
      name: "t.a.settings.document.transfer",
      component: () =>
          import ('@/components/tenancy/admin/settings/document/transfer-product/Index.vue'),
      meta: {
          title: 'Transfer Product',
          icon: '',
          breadcrumb: [
              { name: "Settings", link: rootUrlPath + "/settings/document" },
              { name: "Transfer Product" },
          ],
          suffix: titleSuffix
      }
  },
    // {
    //     path: rootUrlPath + "/dashboard/list",
    //     name: 'a.t.dashboard.list',
    //     component: () =>
    //         import ('@/components/tenancy/admin/dashboard/list/Index.vue'),
    //     meta: {
    //         title: 'List Dashboard',
    //         icon: '',
    //         breadcrumb: [
    //             { name: "List Dashboard", link: rootUrlPath + "/dashboard/list" },
    //         ],
    //         suffix: titleSuffix
    //     }
    // },
    // {
    //     path: "/blog/single/:id",
    //     name: "a.t.blog.single",
    //     component: () =>
    //         import ('@/components/tenancy/admin/blog/BlogSingle.vue'),
    //     meta: {
    //         title: 'Blog',
    //         icon: '',
    //         breadcrumb: [
    //             { name: "blog single", link: rootUrlPath + "/dashboard/list" },
    //         ],
    //         suffix: titleSuffix
    //     }
    // },
    {
        path: rootUrlPath + "/lead/manage",
        name: "t.a.lead.manage",
        component: () =>
            import ('@/components/tenancy/admin/lead/ManageLead'),
        meta: {
            title: 'Manage Lead',
            icon: '',
            breadcrumb: [
                { name: "Lead", link: rootUrlPath + "/lead/manage" },
                { name: "Manage Lead" }
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/lead/view/:id",
        name: "a.t.lead.view",
        component: () =>
            import ('@/components/tenancy/admin/lead/View'),
        meta: {
            title: 'Manage Lead',
            icon: '',
            breadcrumb: [
                { name: "Lead", link: rootUrlPath + "/lead/manage" },
                { name: "Manage Lead", link: rootUrlPath + "/lead/manage" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/lead/list",
        name: "t.a.lead.list",
        component: () =>
            import ('@/components/tenancy/admin/lead/ManageList'),
        meta: {
            title: 'Manage List',
            icon: '',
            breadcrumb: [
                { name: "Lead", link: rootUrlPath + "/lead/manage" },
                { name: "Manage List" }
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/lead/dashborad",
        name: "t.a.lead.dashboard",
        component: () =>
            import ('@/components/tenancy/admin/lead/dashboard/Index'),
        meta: {
            title: 'Dashboard Call Center',
            icon: '',
            breadcrumb: [
                { name: 'Dashboard Call Center' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/products",
        name: "t.a.products",
        meta: {
            title: 'Products',
            icon: '',
            breadcrumb: [
                { name: 'Products' },
            ],
            suffix: titleSuffix
        },
        component: () =>
            import ('@/components/tenancy/admin/products/Index.vue')
    },
    {
        path: rootUrlPath + "/promotions",
        name: "t.a.promotions",
        meta: {
            title: 'Promotions',
            icon: '',
            breadcrumb: [
                { name: 'Promotions' },
            ],
            suffix: titleSuffix
        },
        component: () =>
            import ('@/components/tenancy/admin/promotions/Index.vue')
    },
    {
        path: rootUrlPath + "/variations",
        name: "t.a.variations",
        meta: {
            title: 'Variations',
            icon: '',
            breadcrumb: [
                { name: 'Variations' },
            ],
            suffix: titleSuffix
        },
        component: () =>
            import ('@/components/tenancy/admin/variation/Index.vue')
    },
    {
        path: rootUrlPath + "/productlink",
        name: "t.a.productlink",
        meta: {
            title: 'Product Link',
            icon: '',
            breadcrumb: [
                { name: 'Product Link' },
            ],
            suffix: titleSuffix
        },
        component: () =>
            import ('@/components/tenancy/admin/productlink/Index.vue')
    },
    {
        path: rootUrlPath + "/category",
        name: "t.a.category",
        meta: {
            title: 'Category',
            icon: '',
            breadcrumb: [
                { name: 'Category' },
            ],
            suffix: titleSuffix
        },
        component: () =>
            import ('@/components/tenancy/admin/category/Index.vue')
    },
    {
        path: rootUrlPath + "/social-commerce/live",
        name: "t.a.live.list",
        component: () =>
            import ('@/components/tenancy/admin/social-commerce/live/LiveList'),
        meta: {
            title: 'Live',
            icon: '',
            breadcrumb: [
                { name: "Social Commerce", link: rootUrlPath + "/social-commerce/live" },
                { name: "Live" }
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/social-commerce/live/view/:id",
        name: "t.a.live.view",
        component: () =>
            import ('@/components/tenancy/admin/social-commerce/live/LiveView'),
        meta: {
            title: 'Manage Live',
            icon: '',
            breadcrumb: [
                { name: "Social Commerce" },
                { name: "Live", link: rootUrlPath + "/social-commerce/live" },
                { name: "Manage Live" }
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/print/:encrypturl",
        name: "t.a.print.index",
        component: () =>
            import ('@/components/tenancy/admin/print/Index.vue'),
        meta: {
            title: 'Print Document',
            layout: 'tenancy-admin-layout-no-header',
            icon: '',
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/notifications",
        name: "t.a.notification.index",
        component: () =>
            import ('@/components/tenancy/admin/notifications/Index.vue'),
        meta: {
            title: 'Notification',
            icon: '',
            layout: 'tenancy-admin-layout',
            breadcrumb: [
                { name: 'Notification' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/reports/products/ReportReturn",
        name: "admin.reports.products.return",
        component: () =>
            import ('@/components/tenancy/admin/report/product/Return.vue'),
        meta: {
            title: 'Parcel Return Report',
            icon: '',
            layout: 'tenancy-admin-layout',
            breadcrumb: [
                { name: 'Reports', link: rootUrlPath + "/reports" },
                { name: 'Parcel Return Report'},
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/settings/sale/sale-contact",
        name: "t.a.sale.salecontact",
        component: SaleContact,
        meta: {
            title: 'Sale Contact',
            icon: '',
            layout: 'tenancy-admin-layout',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/buying-selling" },
                { name: "Sale Contact" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/account-setting/shippingcredit",
        name: "t.a.account-setting.shippingcredit",
        component: () =>
            import ('@/components/tenancy/admin/account-setting/shippingcredit/Index.vue'),
        meta: {
            title: 'Shipping Credit',
            icon: '',
            switchLeftMenuMyAccount : true,
            breadcrumb: [
                { name: "Shipping Credit" }
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/account-setting/shippingbilling",
        name: "t.a.account-setting.shippingbilling",
        component: () =>
            import ('@/components/tenancy/admin/account-setting/shippingcredit/ShippingCreditBilling.vue'),
        meta: {
            title: 'Shipping Billing',
            icon: '',
            switchLeftMenuMyAccount : true,
            breadcrumb: [
                { name: "Shipping Credit", link: rootUrlPath + "/account-setting/shippingcredit" },
                { name: "Shipping Billing" }
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/account-setting/smscredit",
        name: "t.a.account-setting.smscredit",
        component: () =>
            import ('@/components/tenancy/admin/account-setting/sms/Index.vue'),
        meta: {
            title: 'SMS Credit',
            icon: '',
            switchLeftMenuMyAccount : true,
            breadcrumb: [
                { name: "SMS" }
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/account-setting/smsbilling",
        name: "t.a.account-setting.smsbilling",
        component: () =>
            import ('@/components/tenancy/admin/account-setting/sms/SmsBilling.vue'),
        meta: {
            title: 'SMS Billing',
            icon: '',
            switchLeftMenuMyAccount : true,
            breadcrumb: [
                { name: "SMS", link: rootUrlPath + "/account-setting/smscredit" },
                { name: "SMS Billing" },
            ]
        }
    },
    {
        path: rootUrlPath + "/premium-subscriptions",
        name: "t.a.premium.subscriptions",
        component: () =>
            import ('@/components/tenancy/admin/account-setting/premium-subscriptions/PremiumSubscriptionsIndex'),
        meta: {
            title: 'Premium Subscriptions',
            icon: '',
            switchLeftMenuMyAccount : true,
            breadcrumb: [
                { name: 'Premium Subscriptions' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + '/marketplaces/callback/:storename',
        component: () =>
            import ('@/components/tenancy/admin/callback/Marketplaces.vue'),
        name: 't.a.marketplaces',
        meta: {
            title: 'Marketplaces',
            layout: 'TenancyPublicLayout',
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + '/socialnetwork/callback/:storename',
        component: () =>
            import ('@/components/tenancy/admin/callback/SocialNetwork.vue'),
        name: 't.a.socialnetwork',
        meta: {
            title: 'Social Network',
            layout: 'TenancyPublicLayout',
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + '/socialnetwork/reauthorize/callback',
        component: () =>
            import ('@/components/tenancy/admin/callback/Reauthorize.vue'),
        name: 't.a.socialnetwork',
        meta: {
            title: 'Social Network',
            layout: 'TenancyPublicLayout',
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + '/socialnetwork/callback',
        component: () =>
            import ('@/components/tenancy/admin/callback/SocialNetwork.vue'),
        name: 't.a.socialnetwork',
        meta: {
            title: 'Social Network',
            layout: 'TenancyPublicLayout',
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + '/socialnetwork/:type/pages',
        component: () =>
            import ('@/components/tenancy/admin/Integrateorigin/SocialNetworkPages.vue'),
        name: 't.a.socialnetwork',
        meta: {
            title: 'Social Network Pages',
            layout: 'TenancyPublicLayout',
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/premium-subscriptions/select-plan",
        name: "t.a.premium.subscriptions.select",
        component: () =>
            import ('@/components/tenancy/admin/account-setting/premium-subscriptions/SelectPlan'),
        meta: {
            title: 'Premium Subscriptions',
            icon: '',
            switchLeftMenuMyAccount : true,
            breadcrumb: [
                { name: 'Premium Subscriptions', link: rootUrlPath + "/premium-subscriptions" },
                { name: "Select Plan" },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/account-setting/billing",
        name: "t.a.account-setting.billing",
        component: () =>
            import ('@/components/tenancy/admin/account-setting/billing/Index.vue'),
        meta: {
            title: 'Subscriptions Billing',
            icon: '',
            switchLeftMenuMyAccount : true,
            breadcrumb: [
                { name: 'Premium Subscriptions', link: rootUrlPath + "/premium-subscriptions" },
                { name: 'Subscriptions Billing' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/service-credit",
        name: "t.a.service-credit.index",

        component: () =>
            import ('@/components/tenancy/admin/account-setting/service-credit/Index.vue'),
        meta: {
            title: 'Service Credit',
            icon: '',
            switchLeftMenuMyAccount : true,
            breadcrumb: [
                { name: "Service Credit" }
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/purchase-apps",
        name: "t.a.purchase-apps.index",

        component: () =>
            import ('@/components/tenancy/admin/account-setting/purchase-apps/Index.vue'),
        meta: {
            title: 'Apps',
            icon: '',
            switchLeftMenuMyAccount : true,
            breadcrumb: [
                { name: "Apps" }
            ],
            suffix: titleSuffix
        }
    },
    {
        path: rootUrlPath + "/payments/index",
        name: "t.a.payments.index",
        component: () =>
            import ('@/components/tenancy/admin/payments/Index.vue'),
        meta: {
            title: 'Payment',
            icon: '',
            layout: 'tenancy-admin-layout',
            breadcrumb: [
                { name: 'Payment' },
            ],
            suffix: titleSuffix
        }
    },
    {
        path: "/chk-status",
        name: "order.link.check.status",
        component: () =>
            import ('@/components/tenancy/public/order_links/Index'),
        meta: {
            layout: 'tenancy-public-layout',
            title: 'Check Status',
            suffix: titleSuffix
        }
    },
    {
        path: "/chk-order",
        name: "order.link.check.order",
        component: () =>
            import ('@/components/tenancy/public/order_links/Detail'),
        meta: {
            layout: 'tenancy-public-layout',
            title: 'Order Detail',
            suffix: titleSuffix
        }
    },
    {
      path: rootUrlPath + "/inventories",
      name: "t.a.inventory",
      meta: {
          title: '_inventory.Inventory',
          icon: '',
          breadcrumb: [
              { name: '_inventory.Inventory' },
          ],
          suffix: titleSuffix
      },
      component: () =>
          import ('@/components/tenancy/admin/inventory/inventoryList/Index.vue')
    },
    {
      path: rootUrlPath + "/inventories",
      name: "t.a.inventory-list",
      meta: {
          title: '_inventory.Inventory Lists',
          icon: '',
          breadcrumb: [
              { name: '_inventory.Inventory Lists' },
          ],
          suffix: titleSuffix
      },
      component: () =>
          import ('@/components/tenancy/admin/inventory/inventoryList/InventoryList.vue')
    },
    {
      path: rootUrlPath + "/warehouses",
      name: "t.a.warehouse",
      meta: {
          title: 'Warehouse',
          icon: '',
          breadcrumb: [
              { name: 'warehouse' },
          ],
          suffix: titleSuffix
      },
      component: () =>
          import ('@/components/tenancy/admin/inventory/warehouse/Index.vue')
    },
    {
        path: rootUrlPath + "/movements",
        name: "t.a.stock-movement",
        meta: {
            title: '_Plan.Stock Movement',
            icon: '',
            breadcrumb: [
                { name: '_Plan.Stock Movement' },
            ],
            suffix: titleSuffix
        },
        component: () =>
            import ('@/components/tenancy/admin/inventory/stock-movement/Index.vue')
      },
    {
        path: rootUrlPath + "/settings/order-management",
        name: "t.a.settings.order-management",
        component: () =>
            import ('@/components/tenancy/admin/settings/order-management/Index'),
        meta: {
            title: 'Order Management',
            icon: '',
            breadcrumb: [
                { name: "Settings", link: rootUrlPath + "/settings/buying-selling" },
                { name: "Buying & Selling", link: rootUrlPath + "/settings/order-management" },
            ],
            suffix: titleSuffix
        }
    },
    {
      path: rootUrlPath + "/settings/inventory-management",
      name: "t.a.settings.inventory-management",
      component: () =>
          import ('@/components/tenancy/admin/settings/inventory-management/Index'),
      meta: {
          title: 'Inventory Management',
          icon: '',
          breadcrumb: [
              { name: "Settings", link: rootUrlPath + "/settings/buying-selling" },
              { name: "Buying & Selling", link: rootUrlPath + "/settings/inventory-management" },
          ],
          suffix: titleSuffix
      }
    },
    {
      path: rootUrlPath + "/purchases",
      name: "t.a.purchases",
      meta: {
          title: 'Purchases',
          icon: '',
          breadcrumb: [
              { name: 'Purchases' },
          ],
          suffix: titleSuffix
      },
      component: () =>
          import ('@/components/tenancy/admin/purchases/Index.vue')
    },
    {
      path: rootUrlPath + "/suppliers",
      name: "t.a.suppliers",
      meta: {
          title: 'Suppliers',
          icon: '',
          breadcrumb: [
              { name: 'Suppliers' },
          ],
          suffix: titleSuffix
      },
      component: () =>
          import ('@/components/tenancy/admin/suppliers/Index.vue')
    },
    {
      path: rootUrlPath + "/automation/index",
      name: "t.a.automation.index",
      component: () =>
          import ('@/components/tenancy/admin/automation/Index.vue'),
      meta: {
          title: 'Automation',
          icon: '',
          layout: 'tenancy-admin-layout',
          breadcrumb: [
              { name: 'Automation' },
          ],
          suffix: titleSuffix
      }
    },
    {
      path: rootUrlPath + "/adjustments",
      name: "t.a.adjustments",
      meta: {
          title: 'Quantity Adjustments',
          icon: '',
          breadcrumb: [
              { name: 'Quantity Adjustments' },
          ],
          suffix: titleSuffix
      },
      component: () =>
          import ('@/components/tenancy/admin/inventory/adjustments/Index.vue')
    },
    {
        path: rootUrlPath + "/transfers",
        name: "t.a.transfers",
        meta: {
            title: 'Transfers',
            icon: '',
            breadcrumb: [
                { name: 'Transfers' },
            ],
            suffix: titleSuffix
        },
        component: () =>
            import ('@/components/tenancy/admin/inventory/transfers/Index.vue')
    },
    {
        path: rootUrlPath,
        name: "admin.fulfillment",
        component: () =>
            import ('@/components/tenancy/admin/fulfillment/Template.vue'),
        children: [
            {
                name: 'admin.fulfillment.order',
                path: 'fulfillment/order',
                component: () => import ('@/components/tenancy/admin/fulfillment/order/Index.vue'),
                meta: {
                    title: 'Order',
                    icon: '',
                    breadcrumb: [
                        { name: "Fulfillment" },
                        { name: "Orders", link: rootUrlPath + "fulfillment/order" },
                    ]
                },
            },
            {
                name: 'admin.fulfillment.connection',
                path: 'fulfillment/connection',
                component: () =>
                    import ('@/components/tenancy/admin/fulfillment/connection/Index.vue'),
                meta: {
                    title: '_Fulfillment.Connection',
                    icon: '',
                    breadcrumb: [
                        { name: "Fulfillment" },
                        { name: '_Fulfillment.Connection' }
                    ]
                },
            },
            {
                name: "admin.fulfillment.products",
                path: "fulfillment/products",
                component: () =>
                    import ('@/components/tenancy/admin/fulfillment/products/Index.vue'),
                meta: {
                    title: 'Products',
                    icon: '',
                    breadcrumb: [
                        { name: 'Products' }
                  ]
                },
            },
        ]
    },
    {
      path: rootUrlPath + "/return-order",
      name: "t.a.return-order",
      meta: {
          title: 'Return Orders',
          icon: '',
          breadcrumb: [
              { name: 'Return Orders' },
          ],
          suffix: titleSuffix
      },
      component: () =>
          import ('@/components/tenancy/admin/returnorder/Index.vue')
    },
    {
        path: "/:catchAll(.*)",
        name: "Not Found",
        component: () =>
            import ('@/components/tenancy/admin/error-page/404.vue'),
        meta: {
            title: 'Not found',
            icon: '',
            breadcrumb: [
                { name: 'Not Found' },
            ],
            suffix: titleSuffix
        }
    },
]

const tenancyRouterWithSuffix = tenancyRouter.map(item => {
    if( "meta" in item ) {
      item.meta['suffix'] = titleSuffix;
    }

    if( "children" in item ){
        item.children = item.children.map(itemChildren => {
          if( "meta" in itemChildren ) {
              itemChildren.meta['suffix'] = titleSuffix;
            }
            return itemChildren
        })
    }
    return item
})

export default tenancyRouterWithSuffix



// WEBPACK FOOTER //
// ./src/router/tenancy.js